/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PinInput} from './components/PinInput'
import {Registration} from './components/Registration'
import {Languages} from '../../../_metronic/partials/layout/header-menus/Languages'

// import {Registration} from './components/Registration'
// import {ForgotPassword} from './components/ForgotPassword'
// import {SetNewPassword} from './components/SetNewPassword'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      // style={{
      //   backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      // }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <div className='d-flex justify-content-center align-items-center flex-wrap mb-12'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/_mstart/logo-original.png')}
            className='h-80px'
          />
          <span className='fw-bolder mx-8' style={{fontSize: '40px'}}>
            VEITL
          </span>
        </div>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          {/* <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a> */}
          <div
            className='menu menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold fs-6 w-250px rounded p-0'
            data-kt-menu='true'
          >
            <Languages />
          </div>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />}>
        <Route path=':email/:bp' element={<Login />} />
        <Route path=':bp' element={<Login />} />
      </Route>
      <Route path='registration' element={<Registration />} />
      {/* <Route path='forgot-password' element={<ForgotPassword />} /> */}
      <Route path='pin-input' element={<PinInput />} />
      {/* <Route path='set-new-password' element={<SetNewPassword />} /> */}
      {/* <Route path="*" element={<Login />} /> */}
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
